import { createContext } from 'react';

import type { SubRoute } from '../types';

type State = {
  loading: boolean;
  /**
   * The selected sub path of the selected sub route.
   */
  selectedSubPath?: string;
  selectedSubRoute?: SubRoute;
  subRoutes: readonly SubRoute[];
};

const SubRouteContext = createContext<State>({
  loading: false,
  subRoutes: [],
});
SubRouteContext.displayName = 'SubRouteContext';

export { SubRouteContext };
